import { validatorTypes } from '@data-driven-forms/react-form-renderer';

const rapido3plFieldMap = {
  fields: [
    {
      component: 'text-field',
      name: 'email',
      label: 'Your Email',
      isRequired: true,
      placeholder: 'Enter your e-mail',
      validate: [
        {
          type: 'required',
        },
        {
          type: validatorTypes.PATTERN,
          pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$/,
          message: 'E-mail ID is incorrect',
        },
      ],
    },
    {
      component: 'radio',
      label: 'Gender',
      name: 'gender',
      options: [
        {
          label: 'Male',
          value: 'male',
        },
        {
          label: 'Female',
          value: 'female',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
    },
    {
      component: 'date-picker',
      label: 'Date Of Birth',
      name: 'dateOfBirth',
      isRequired: true,
      inputReadOnly: true,
      validate: [
        {
          type: 'required',
        },
      ],
    },
    {
      component: 'date-picker',
      label: 'Driving Licence Expiry',
      name: 'dlExpiry',
      inputReadOnly: true,
      isRequired: true,
      inputReadOnly: true,
      validate: [
        {
          type: 'required',
        },
      ],
    },
    {
      component: 'text-field',
      name: 'rcNumber',
      label: 'RC Number',
      isRequired: true,
      validate: [
        {
          type: 'required',
        },
      ],
      placeholder: 'Enter your RC Number',
    },
  ],
};

export default rapido3plFieldMap;
